module.exports = __webpack_public_path__ + "img/phone_frame.d4cdd3fd.png";